import { AxiosError } from "axios";
import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../hooks/useToast";
import { requestPasswordReset } from "../../api";
import TextInput from "../../components/TextInput";
import AuthLayout from "../../layout/AuthLayout";
import Button from "../../components/Button";

export default function RequestPasswordResetPage() {
  const { toast } = useToast();
  const [email, setEmail] = useState<string>("");
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    try {
      if (!email) {
        toast({
          message: "Informe um e-mail válido para continuar.",
          type: "error",
        });
        return;
      }
      setLoading(true);
      await requestPasswordReset(email);
      toast({
        message: "E-mail de recuperação enviado com sucesso",
        type: "success",
      });
      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      let errorMessage =
        "Não foi possível enviar o e-mail. Confira o endereço e tente de novo.";
      if (error instanceof AxiosError) {
        const serverError = error.response?.data;
        if (serverError && serverError.error && serverError.message) {
          errorMessage = serverError.message;
        }
      }
      toast({
        message: errorMessage,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Recuperar senha"
      subtitle="Informe o e-mail da sua conta. Se ele estiver cadastrado, você receberá as instruções."
      homeLink
    >
      <form className="flex flex-col gap-4" onSubmit={submit}>
        <TextInput
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          spellCheck={false}
          variant="outlined"
          label="E-mail"
          placeholder="nome@instituicao.edu.br…"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Enviando…" : "Enviar instruções"}
        </Button>
      </form>
    </AuthLayout>
  );
}
